module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "secondary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("Reload")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "sort-by": _vm.sortBy,
      "item-key": "igHandle"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.createdAt))]), _vm._v(" "), _c('td', {
            staticClass: "justify-center layout px-0"
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', {
                  attrs: {
                    "text": "",
                    "icon": "",
                    "color": "green"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.approveOrReject(1, item.id)
                    }
                  }
                }, [_c('v-icon', _vm._g({}, on), [_vm._v("done_outline")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Approve")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', {
                  attrs: {
                    "text": "",
                    "icon": "",
                    "color": "deep-orange"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.approveOrReject(2, item.id)
                    }
                  }
                }, [_c('v-icon', _vm._g({}, on), [_vm._v("not_interested")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Reject")])])], 1)])
        }), 0)]
      }
    }])
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8cd3d68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/UnApprovedUser.vue
// module id = 2307
// module chunks = 0